export default __webpack_public_path__ + "static/media/element_5.dbf7183d.svg";